(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9733],{

/***/ 58:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashion/women",
      function () {
        return __webpack_require__(31553);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CategorySmallBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
//@ts-nocheck






// import 'slick-carousel/slick/slick.css'


// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
function SampleNextArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/right-icon-black.svg",
            alt: "RightArrow"
        })
    });
}
function SamplePrevArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/left-icon-black.svg",
            alt: "LeftArrow"
        })
    });
}
function CategorySmallBanner(param) {
    var categoryData = param.categoryData, scrollY = param.scrollY, handleClose = param.handleClose, pathname = param.pathname;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 12,
        slidesToScroll: 1,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: "40px"
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "book-application-shop-by-category-small-banner-alignment ".concat(scrollY >= 100 ? "open-nav-alignment" : "hide-nav-alignment"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            style: {
                padding: 0
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "book-application-shop-by-category-small-banner-flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "book-application-shop-by-category-option",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, settings), {
                        children: categoryData === null || categoryData === void 0 ? void 0 : categoryData.map(function(cat, index) {
                            var ref, ref1, ref2;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "book-application-shop-by-category-link-alignment",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: "".concat(pathname, "/").concat(cat === null || cat === void 0 ? void 0 : cat.slug),
                                        scroll: false,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === (cat === null || cat === void 0 ? void 0 : (ref2 = cat.slug) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) ? "menu-active" : "",
                                            children: cat === null || cat === void 0 ? void 0 : cat.name
                                        })
                                    })
                                }, index)
                            });
                        })
                    }))
                })
            })
        })
    });
}


/***/ }),

/***/ 20774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TrendingProductCommon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_store_slices_guestAccountDetailSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33305);
/* harmony import */ var src_store_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74573);
/* harmony import */ var src_components_FindStyleNodata__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95371);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);






function TrendingProductCommon(param) {
    var Cards = param.Cards;
    var dispatch = (0,src_store_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .T)();
    var handleRedirect = function() {
        dispatch((0,src_store_slices_guestAccountDetailSlice__WEBPACK_IMPORTED_MODULE_2__/* .guestAccountDetailSlice */ .Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    var handleProductOpen = function(product) {
    // dispatch(
    //   fetchModalData({
    //     allModalData: [
    //       ...getAllState?.allModalData,
    //       {
    //         modal: 'productDetail',
    //         isOpen: true,
    //         store_id: 0,
    //         id: product?.id,
    //         modalFor: 'bigModal',
    //         startDate: moment().toISOString(),
    //       },
    //     ],
    //     lastModalData: getAllState?.lastModalData,
    //   }),
    // )
    };
    return  true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "row trending_product_block_row ",
        children: Cards.map(function(Data, i) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: Data.parent_fill ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "card_col ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    href: "/product/".concat((ref = Data.child[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.product_data) === null || ref1 === void 0 ? void 0 : ref1.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "cardcover",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "card_top",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: (ref2 = Data.child[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.product_data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.images) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.src,
                                                    alt: "card_top_img"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "card_bottom",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "WomeCardContent",
                                                    onClick: function() {
                                                        var ref;
                                                        return handleProductOpen((ref = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref === void 0 ? void 0 : ref.product_data);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                            children: (ref6 = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.product_data) === null || ref7 === void 0 ? void 0 : ref7.title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "WomenCardPrice",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    children: [
                                                                        "$",
                                                                        (ref8 = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.product_data) === null || ref9 === void 0 ? void 0 : ref9.dis_price
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("del", {
                                                                    children: [
                                                                        ((ref10 = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.product_data) === null || ref11 === void 0 ? void 0 : ref11.dis_listPrice) ? "$" : "",
                                                                        " ",
                                                                        (ref12 = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.product_data) === null || ref13 === void 0 ? void 0 : ref13.dis_listPrice,
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    href: "/product/".concat((ref14 = Data.child[1]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.product_data) === null || ref15 === void 0 ? void 0 : ref15.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "cardcover",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "card_top",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: (ref16 = Data.child[1]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.product_data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.images) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.src,
                                                    alt: "card_top_img"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "card_bottom",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "WomeCardContent",
                                                    onClick: function() {
                                                        var ref;
                                                        return handleProductOpen((ref = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref === void 0 ? void 0 : ref.product_data);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                            children: (ref20 = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.product_data) === null || ref21 === void 0 ? void 0 : ref21.title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "WomenCardPrice",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    children: [
                                                                        "$",
                                                                        (ref22 = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.product_data) === null || ref23 === void 0 ? void 0 : ref23.dis_price
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("del", {
                                                                    children: [
                                                                        ((ref24 = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.product_data) === null || ref25 === void 0 ? void 0 : ref25.dis_listPrice) ? "$" : "",
                                                                        " ",
                                                                        (ref26 = Data === null || Data === void 0 ? void 0 : Data.child[0]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.product_data) === null || ref27 === void 0 ? void 0 : ref27.dis_listPrice,
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, "q".concat(i + 1))
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "card_col",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                            href: "/product/".concat(Data === null || Data === void 0 ? void 0 : (ref28 = Data.product_data) === null || ref28 === void 0 ? void 0 : ref28.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "cardcover",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card_top",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: Data === null || Data === void 0 ? void 0 : (ref29 = Data.product_data) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.images) === null || ref30 === void 0 ? void 0 : (ref31 = ref30[0]) === null || ref31 === void 0 ? void 0 : ref31.src,
                                            alt: "card_top_img"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card_bottom",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "WomeCardContent",
                                            onClick: function() {
                                                return handleProductOpen(Data === null || Data === void 0 ? void 0 : Data.product_data);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                    children: Data === null || Data === void 0 ? void 0 : (ref32 = Data.product_data) === null || ref32 === void 0 ? void 0 : ref32.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "WomenCardPrice",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            children: [
                                                                "$",
                                                                Data === null || Data === void 0 ? void 0 : (ref33 = Data.product_data) === null || ref33 === void 0 ? void 0 : ref33.dis_price
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("del", {
                                                            children: [
                                                                (Data === null || Data === void 0 ? void 0 : (ref34 = Data.product_data) === null || ref34 === void 0 ? void 0 : ref34.dis_listPrice) ? "$" : "",
                                                                " ",
                                                                Data === null || Data === void 0 ? void 0 : (ref35 = Data.product_data) === null || ref35 === void 0 ? void 0 : ref35.dis_listPrice,
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }, i);
        })
    }) : /*#__PURE__*/ 0;
}


/***/ }),

/***/ 95371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _FindStyleNodata_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30806);
/* harmony import */ var _FindStyleNodata_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_FindStyleNodata_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var FindStyleNodatasvg = "/assets/img/Menstylesnodata.svg";
function FindStyleNodata() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_FindStyleNodata_module_scss__WEBPACK_IMPORTED_MODULE_2___default().FindStyleNodatamain),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_FindStyleNodata_module_scss__WEBPACK_IMPORTED_MODULE_2___default().FindStyleNodatabox),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: FindStyleNodatasvg,
                        alt: "FindStyleNodatasvg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "We don't have any trending products right now, please check back soon!"
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FindStyleNodata);


/***/ }),

/***/ 31553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ women; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(60430);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./src/store/store.tsx + 6 modules
var store = __webpack_require__(74573);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenCategorySections/WomenBannerSection.tsx






function WomenBannerSection(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
        pauseOnHover: true
    };
    var WomenBannerVideo = [
        "https://bluejestic-media.storage.googleapis.com/bluejestic-stage/women/banner/cute-young-girl-with-dark-wavy-hairstyle-bright-makeup-silk-dress-black-jacket-holding-sunglasses-hands-looking-away-against-beige-building-wall 1-1702284503236-715549938.png", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "section_1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bannner_slider",
            children: (0,_to_consumable_array/* default */.Z)(Array(1)).map(function(data, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bannner_slider_cover",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "img_cover",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                loop: true,
                                autoPlay: true,
                                muted: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: "https://bluejestic-media.storage.googleapis.com/bluejestic-stage/store/admin/globus_women's_fashion (1080p)-1705645131385-552419583.mp4",
                                    type: "video/mp4"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "banner_content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content_cover",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: "New Collection"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "subtext",
                                            children: "We're Coming In Hot With Sequins And Satin Paired With Moody Metallic Leather"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "banner_btn",
                                            onClick: function() {
                                                router.push("/search/?q=leather+jacket&type=product");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Shop Now"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }, index);
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./src/utils/auth.tsx
var auth = __webpack_require__(23174);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./public/assets/fashion/women/fashionbannersliderimage1.png
/* harmony default export */ var fashionbannersliderimage1 = ({"src":"/_next/static/media/fashionbannersliderimage1.340f77a2.png","height":222,"width":472,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAeElEQVR42g3LQQrCQBBE0d/tJBMMmKA7QdATegiv5lZXbgXPYEKCycy0XdSiFq/kfrsW8eAtOSFAyhlVRcCC1Y2YCHldqHTDdxiYi/gWuqaSkH6rs4gtydHM4/lyYPRauJxPaN12tj0caXc90zgyfd7sA/ibEKP9AbppLLqDSY9+AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/fashion/women/fashionbannersliderimage2.png
/* harmony default export */ var fashionbannersliderimage2 = ({"src":"/_next/static/media/fashionbannersliderimage2.3afc7b4c.png","height":222,"width":472,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAj0lEQVR4nAGEAHv/AT09Yv4M+/kB+Pv4APf09AD9CgIA0f4JAEsP+AADCxP/AUZBX/8PA/gA//DoAO8REwBHNRoAGQ4aAB8ZJQDKyr0AAVNJY/8yFggA2OPgAKPh4QCFZmEAQUNGAP/wHAD35+wAAWM/Yf5FEwoBzOvvAIzE2ABIW0kASVRTACj+DQD86fL/2xQ1q6FXuowAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/fashion/women/fashionbannersliderimage3.png
/* harmony default export */ var fashionbannersliderimage3 = ({"src":"/_next/static/media/fashionbannersliderimage3.6322526a.png","height":222,"width":472,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAj0lEQVR4nAGEAHv/AQAAAP6OeXEBRTUsAP738QDu6ucAudDcAIihrwAaFBL/AQAJAP9kSEkAak1AAAD//QDd4uQAn7O9ALbO2QANDA0AAWRNV/8KBg4AQC0UAPkB+gDx6uoA9fjtAKrBzQDg3OkAAZ9IY/4qISEB+RD9APAV/ADs5OMALCwjAPf5+wD4/wP/9uc5TCgV6SQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenCategorySections/ShopCardSection.tsx
// @ts-nocheck











function ShopCardSection() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var user = (0,auth/* useAuth */.a)().user;
    var router = (0,next_router.useRouter)();
    var settings = {
        dots: false,
        // infinite: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        centerPadding: "26px",
        className: "center",
        arrows: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    variableWidth: true
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    variableWidth: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "section_2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "section_2_slider_main_web",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "section_2_slider",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "section_2_slider_content",
                                onClick: function() {
                                    router.push("/store/mkfcollection");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: fashionbannersliderimage1.src,
                                    alt: "img_cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "section_2_slider_content",
                                onClick: function() {
                                    router.push("/search/?q=summer%20dress&type=product");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: fashionbannersliderimage2.src,
                                    alt: "img_cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "section_2_slider_content",
                                onClick: function() {
                                    router.push("/store/adinaeden");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: fashionbannersliderimage3.src,
                                    alt: "img_cover"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "section_2_slider_main_mobile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "section_2_slider_content",
                                onClick: function() {
                                    router.push("/store/mkfcollection");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: fashionbannersliderimage1.src,
                                    alt: "img_cover"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "section_2_slider_content",
                                onClick: function() {
                                    router.push("/search/?q=summer%20dress&type=product");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: fashionbannersliderimage2.src,
                                    alt: "img_cover"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "section_2_slider_content",
                                onClick: function() {
                                    router.push("/store/adinaeden");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: fashionbannersliderimage3.src,
                                    alt: "img_cover"
                                })
                            })
                        })
                    ]
                }))
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/store/slices/manageApplianceCategorySlice.tsx + 2 modules
var manageApplianceCategorySlice = __webpack_require__(18829);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/slices/fetchCategory.tsx
var fetchCategory = __webpack_require__(4629);
// EXTERNAL MODULE: ./src/store/slices/fetchAllPeopleSlice.tsx + 1 modules
var fetchAllPeopleSlice = __webpack_require__(77610);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenCategorySections/ShopByWomenCategory.tsx
// @ts-nocheck












function ShopByWomenCategory() {
    var ref;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var MobileshopByProduct = {
        className: "center",
        // centerMode: true,
        infinite: false,
        variableWidth: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        speed: 500,
        rows: 1,
        slidesPerRow: 2
    };
    var ref1 = (0,react.useState)(1), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,react.useState)(15), limit = ref2[0], setLimit = ref2[1];
    var router = (0,next_router.useRouter)();
    var sub_category_slug = router === null || router === void 0 ? void 0 : router.pathname.split("/")[2];
    var categoryData = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.fetchCategory) === null || ref === void 0 ? void 0 : ref.womenCategoryData;
    });
    (0,react.useEffect)(function() {
        dispatch((0,fetchCategory/* fetchCategoryBySlug */.E)({
            type: "CHILD_SUB_CATEGORY",
            categoryName: "Fashion & Accessories",
            subcategoryName: sub_category_slug,
            childsubSlug: "",
            nestedSlug: ""
        }));
    }, []);
    (0,react.useEffect)(function() {
        dispatch((0,fetchAllPeopleSlice/* fetchAllPeople */.v)({
            limit: limit,
            page: page,
            type: "ALL_PEOPLE",
            prevPost: [],
            gender: "Female"
        }));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "section_3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row section_3_row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "left_block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "left_cover",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Shop By Category"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "right_block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "right_block_cover",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider2, {
                                        colletionData: categoryData
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mobile_view_section3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "section_3_heading",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Categories"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: "/fashion/women/".concat(categoryData && ((ref = categoryData[0]) === null || ref === void 0 ? void 0 : ref.slug))
                                },
                                scroll: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mobile_view_seeMore",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "See More"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile_view_section3_details_alignment",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile_view_section3_details_bg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, MobileshopByProduct), {
                                children: categoryData === null || categoryData === void 0 ? void 0 : categoryData.map(function(childSubCategory, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: {
                                                pathname: "/fashion/women/".concat(childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.slug)
                                            },
                                            scroll: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mobile_view_gridItem",
                                                onClick: function() {
                                                    dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                                        modal: "womenShopByCategory",
                                                        isOpen: true,
                                                        id: childSubCategory.name,
                                                        isMobile: false
                                                    }));
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "imgBox-alignment",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.media,
                                                            alt: "Category_slider_cover_img"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product_name-alignment",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.name
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }, index);
                                })
                            }))
                        })
                    })
                ]
            })
        ]
    });
}
var SampleNextArrow = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "slick-arrow slick-next",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "6",
            height: "12",
            viewBox: "0 0 6 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 1L1 6L5 11",
                stroke: "#1E2432",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var SamplePrevArrow = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "slick-arrow slick-prev",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "6",
            height: "12",
            viewBox: "0 0 6 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 1L1 6L5 11",
                stroke: "#1E2432",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var Slider2 = function(param) {
    var colletionData = param.colletionData;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var settings_Slider2 = {
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 8,
        slidesToScroll: 8,
        autoplay: false,
        autoplaySpeed: 10000,
        pauseOnHover: true,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SamplePrevArrow, {}),
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 10,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 10,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 968,
                settings: {
                    slidesToShow: 4.5,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "Category_slider",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings_Slider2), {
                children: colletionData === null || colletionData === void 0 ? void 0 : colletionData.map(function(childSubCategory, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/fashion/women/".concat(childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.slug),
                            scroll: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "Category_slider_cover",
                                onClick: function() {
                                    dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                        modal: "womenShopByCategory",
                                        isOpen: true,
                                        id: childSubCategory.name,
                                        isMobile: false
                                    }));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "catagory_block",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "box_cover",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "box",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "img_cover",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.media,
                                                        alt: "Category_slider_cover_img"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.name
                                        })
                                    ]
                                })
                            })
                        })
                    }, index);
                })
            }))
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/s1.png
/* harmony default export */ var s1 = ({"src":"/_next/static/media/s1.0dc5f252.png","height":221,"width":260,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAA4klEQVR42g3Ku07CYABA4VP+n9JSbIKVRDEaGiYXBwdnVx/A9+FRXBxJnJmVESMxDUJjNEbb1EvbpCKUXuh4Tj6lKMtsdDsU4+ENV5cXGKpg6sy4vp9RL9JcbrJU+K9zFFnjOwhY6Sr5JkWtuq5oQkKN9D/lzO7hJWuepy6mWr2/mKJhUPt0HYRSYB/t4y1cHiZzOu0dygokywTxOB4NersWXdPksNPi9Nji7WWB8+6jN3VkU2sRJxFBFCDzJVES8/Txw1o06Jsa0u5aWfjri8HdhPOTPl9hiBevONhrY2havgUtQl5RO+1wCgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/s2.png
/* harmony default export */ var s2 = ({"src":"/_next/static/media/s2.a0c0fb9c.png","height":253,"width":260,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA8klEQVR42g3Iu07CUACA4b/tQUoN0UETEXYkbrqb+ACOvo+bu2/iO2icDInECAqGCAdLLb2kpJdj26Pf+Bnvi0C1bNsqtYlSNV4QUtcVoS9ZrpaVyJVuGMKkSGK2kYdcTomTBE9O0cIxhRAW8deM1fM9o5c3KjS9doaMCpz2IdZFp3nj3t3iFgGL1yEtS+D0ukzkB/H6G9P9T/k4JB5LPlWTOEvZOehzcjxAaY15dHWJc3bK5mnCj7emzBSVK+nOAzBMRKoi7EGHvQKuz/s4YcJvnrCeT8krHzEbj/Mi34j93Ya2oojtw4jUd0kNw2jZzfIP52aAdhfT9+4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/s3.png
/* harmony default export */ var s3 = ({"src":"/_next/static/media/s3.f46ed321.png","height":484,"width":260,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAfElEQVR42gWAMQ6CMBRAX9svLUijLDq4OHt5VwcPYbyAcXATEhMEapvWqOvlnKxzKA05RvRm25lPP5j++TCt90Zs7ZEwsTYKsQ2SUqCpNLvjCXEWGd8vstRU1iGmoMM80XQeqS3Td0SWqBjuN9Qy0+4PSCyaGU0omVX88QfIxytP5eVw7gAAAABJRU5ErkJggg==","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/s4.png
/* harmony default export */ var s4 = ({"src":"/_next/static/media/s4.daa19e89.png","height":484,"width":260,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAiklEQVR42gWAsQqCQABAn3fXXWREe0u/ELTUN7T0n31DUU4hRINBixiSUA2J6JWUeeFdsuSbhoFX5JbJYokyuqPy+43GabrGID4vS2UtUZzQNg2itiWtLYiDFdHxgBAOWuPzfEv22w1CdiTD0RinfabzGeJxTTnt1kgcfr+H0kr8Bl7tZeEZW1buDw5AO2qjlD2NAAAAAElFTkSuQmCC","blurWidth":4,"blurHeight":8});
// EXTERNAL MODULE: ./src/store/slices/guestAccountDetailSlice.tsx
var guestAccountDetailSlice = __webpack_require__(33305);
// EXTERNAL MODULE: ./src/utils/AosAnimation.tsx
var AosAnimation = __webpack_require__(48991);
// EXTERNAL MODULE: ./src/graphql/queries/getAllProducts.tsx
var getAllProducts = __webpack_require__(76714);
// EXTERNAL MODULE: ./src/utils/apolloClient.ts
var apolloClient = __webpack_require__(16915);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenCategorySections/WomenTredingSection.tsx
// @ts-nocheck



















function WomenTredingSection() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(1), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(35), dataLimite = ref1[0], setDataLimite = ref1[1];
    var ref2 = (0,react.useState)([]), productData = ref2[0], setProductData = ref2[1];
    var productByCategory = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.productByCategory;
    });
    var getAllState = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    var ref3 = (0,react.useState)([]), allProductData = ref3[0], setAllProductData = ref3[1];
    (0,react.useEffect)(function() {
        setPage(1);
        fetchProduct();
    }, []);
    var fetchProduct = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apolloClient/* default.query */.Z.query({
                                query: getAllProducts/* default */.Z,
                                variables: {
                                    categoryName: "fashion-and-accessories",
                                    subCategoryName: (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("women")) ? "women" : "men",
                                    childSubCategoryName: (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.category) ? router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.category : "",
                                    isShopifyProduct: false,
                                    page: page,
                                    limit: dataLimite,
                                    order: "like_count"
                                },
                                fetchPolicy: "network-only"
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        setAllProductData(data === null || data === void 0 ? void 0 : (ref3 = data.getAllProducts) === null || ref3 === void 0 ? void 0 : ref3.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchProduct() {
            return _ref.apply(this, arguments);
        };
    }();
    var Cards = [
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small",
                    product: true
                },
                {
                    img: s2,
                    type: "small",
                    product: true
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            product: true,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s2,
                    type: "small",
                    product: true
                },
                {
                    img: s1,
                    type: "small",
                    product: true
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            product: true,
            child: []
        },
        {
            img: s3,
            type: "large",
            parent_fill: false,
            product: true,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small",
                    product: true
                },
                {
                    img: s2,
                    type: "small",
                    product: true
                }, 
            ]
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small",
                    product: true
                },
                {
                    img: s2,
                    type: "small",
                    product: true
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            product: true,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s2,
                    type: "small",
                    product: true
                },
                {
                    img: s1,
                    type: "small",
                    product: true
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            product: true,
            child: []
        },
        {
            img: s3,
            type: "large",
            parent_fill: false,
            product: true,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small",
                    product: true
                },
                {
                    img: s2,
                    type: "small",
                    product: true
                }, 
            ]
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small",
                    product: true
                },
                {
                    img: s2,
                    type: "small",
                    product: true
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            product: true,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s2,
                    type: "small",
                    product: true
                },
                {
                    img: s1,
                    type: "small",
                    product: true
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            product: true,
            child: []
        },
        {
            img: s3,
            type: "large",
            parent_fill: false,
            product: true,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small",
                    product: true
                },
                {
                    img: s2,
                    type: "small",
                    product: true
                }, 
            ]
        }, 
    ];
    var settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 5.5,
        slidesToScroll: 3,
        lazyLoad: true,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 5.5,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false,
                    lazyLoad: true,
                    pauseOnHover: true
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5.5,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false,
                    lazyLoad: true,
                    pauseOnHover: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4.5,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false,
                    lazyLoad: true,
                    pauseOnHover: true
                }
            },
            {
                breakpoint: 968,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                    lazyLoad: true,
                    pauseOnHover: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    lazyLoad: true,
                    pauseOnHover: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    slidesToScroll: 1,
                    lazyLoad: true,
                    pauseOnHover: true
                }
            }, 
        ]
    };
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    (0,react.useEffect)(function() {
        if ((allProductData === null || allProductData === void 0 ? void 0 : allProductData.length) > 0) {
            var i = 0;
            var result = Cards.map(function(card, index) {
                if (card.product) {
                    card.product_data = allProductData[i];
                    i++;
                }
                if (card.child) {
                    card.child = card.child.map(function(child, ind) {
                        if (child.product) {
                            child.product_data = allProductData[i];
                            i++;
                        }
                        return child;
                    });
                }
                return card;
            });
            setProductData(result);
        }
    }, [
        allProductData
    ]);
    var handleProductOpen = function(product) {
        router.push("/product/".concat(product.slug));
    };
    return (productData === null || productData === void 0 ? void 0 : productData.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "section_4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AosAnimation/* default */.Z, {
                animationType: "fade-up",
                duration: 500,
                delay: 150,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "section_4_head",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Now Trending"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: "/fashion/women",
                                    query: {
                                        type: "trending"
                                    }
                                },
                                scroll: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "See All"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "section_4_heading",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Now Trending"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: "/fashion/women",
                                    query: {
                                        type: "trending"
                                    }
                                },
                                scroll: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mobile_view_seeMore",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "See More"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "trending_block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "trending_block_row ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                        children: productData === null || productData === void 0 ? void 0 : productData.map(function(prd, i) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: prd.parent_fill ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AosAnimation/* default */.Z, {
                                    animationType: "fade-up",
                                    duration: 1000,
                                    delay: 50,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "card_col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cardcover",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cart_height1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (ref2 = (ref = prd === null || prd === void 0 ? void 0 : prd.child[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.product_data) === null || ref1 === void 0 ? void 0 : ref1.images[0]) === null || ref2 === void 0 ? void 0 : ref2.src,
                                                            alt: "card_top_img"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card_bottom",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "WomeCardContent",
                                                            onClick: function() {
                                                                var ref;
                                                                return handleProductOpen((ref = prd === null || prd === void 0 ? void 0 : prd.child[0]) === null || ref === void 0 ? void 0 : ref.product_data);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    children: (ref3 = prd === null || prd === void 0 ? void 0 : prd.child[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.product_data) === null || ref4 === void 0 ? void 0 : ref4.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "WomenCardPrice",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            children: [
                                                                                "$",
                                                                                (ref5 = prd === null || prd === void 0 ? void 0 : prd.child[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.product_data) === null || ref6 === void 0 ? void 0 : ref6.dis_price
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("del", {
                                                                            children: [
                                                                                ((ref7 = prd === null || prd === void 0 ? void 0 : prd.child[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.product_data) === null || ref8 === void 0 ? void 0 : ref8.dis_listPrice) ? "$" : "",
                                                                                " ",
                                                                                (ref9 = prd === null || prd === void 0 ? void 0 : prd.child[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.product_data) === null || ref10 === void 0 ? void 0 : ref10.dis_listPrice,
                                                                                " "
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cardcover",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cart_height2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (ref13 = (ref11 = prd === null || prd === void 0 ? void 0 : prd.child[1]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.product_data) === null || ref12 === void 0 ? void 0 : ref12.images[0]) === null || ref13 === void 0 ? void 0 : ref13.src,
                                                            alt: "card_top_img"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card_bottom",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "WomeCardContent",
                                                            onClick: function() {
                                                                var ref;
                                                                return handleProductOpen((ref = prd === null || prd === void 0 ? void 0 : prd.child[1]) === null || ref === void 0 ? void 0 : ref.product_data);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    children: (ref14 = prd === null || prd === void 0 ? void 0 : prd.child[1]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.product_data) === null || ref15 === void 0 ? void 0 : ref15.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "WomenCardPrice",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            children: [
                                                                                "$",
                                                                                (ref16 = prd === null || prd === void 0 ? void 0 : prd.child[1]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.product_data) === null || ref17 === void 0 ? void 0 : ref17.dis_price
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("del", {
                                                                            children: [
                                                                                ((ref18 = prd === null || prd === void 0 ? void 0 : prd.child[1]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.product_data) === null || ref19 === void 0 ? void 0 : ref19.dis_listPrice) ? "$" : "",
                                                                                " ",
                                                                                (ref20 = prd === null || prd === void 0 ? void 0 : prd.child[1]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.product_data) === null || ref21 === void 0 ? void 0 : ref21.dis_listPrice,
                                                                                " "
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AosAnimation/* default */.Z, {
                                        animationType: "fade-up",
                                        duration: 1500,
                                        delay: 100,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "card_col",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cardcover",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cart_height3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (ref23 = prd === null || prd === void 0 ? void 0 : (ref22 = prd.product_data) === null || ref22 === void 0 ? void 0 : ref22.images[0]) === null || ref23 === void 0 ? void 0 : ref23.src,
                                                            alt: "card_top_img"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card_bottom",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "WomeCardContent",
                                                            onClick: function() {
                                                                return handleProductOpen(prd === null || prd === void 0 ? void 0 : prd.product_data);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    children: prd === null || prd === void 0 ? void 0 : (ref24 = prd.product_data) === null || ref24 === void 0 ? void 0 : ref24.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "WomenCardPrice",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            children: [
                                                                                "$",
                                                                                prd === null || prd === void 0 ? void 0 : (ref25 = prd.product_data) === null || ref25 === void 0 ? void 0 : ref25.dis_price
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("del", {
                                                                            children: [
                                                                                (prd === null || prd === void 0 ? void 0 : (ref26 = prd.product_data) === null || ref26 === void 0 ? void 0 : ref26.dis_listPrice) ? "$" : "",
                                                                                prd === null || prd === void 0 ? void 0 : (ref27 = prd.product_data) === null || ref27 === void 0 ? void 0 : ref27.dis_listPrice
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            }, i);
                        })
                    }))
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
{
/* <Slider {...settings}>
{productData?.map((prd, i) => {
  return (
    <React.Fragment key={i}>
      {prd.parent_fill ? (
        <AosAnimation animationType="fade-up" duration={1000} delay={50}>
          <div className="card_col">{i}
            <div className="cardcover">
              <div className="card_top">
                <img src={prd?.child[0]?.product_data?.images[0]?.src} alt="card_top_img" />
              </div>
              <div className="card_bottom">
                <div className="card_bottom_cover">
                  <h4>Plain And Check Shirts</h4>
                  <p className="amount">
                    <span className="price">$245</span>
                    <span className="orignal_price"> $ 425.00 </span>
                    <span className="discount">40% OFF</span>
                  </p>
                  <p className="hike">
                    <span className="inter">
                      <img src={others.src} alt="hike" /> Interest
                    </span>
                    <span className="incris">
                      <img src={aroww.src} alt="incris" /> 200%
                    </span>
                  </p>
                  <div className="rating">
                    <span className="rating_point">4.8</span>
                    <div className="stars">
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                    </div>
                    <span className="num">(437)</span>
                  </div>
                  <button className="buy_btn" onClick={handleRedirect}>
                    Buy
                  </button>
                </div>
              </div>
            </div>
            <div className="cardcover">
              <div className="card_top">
                <img src={prd?.child[1]?.product_data?.images[0]?.src} alt="card_top_img" />
              </div>
              <div className="card_bottom">
                <div className="card_bottom_cover">
                  <h4>Plain And Check Shirts</h4>
                  <p className="amount">
                    <span className="price">$245</span>
                    <span className="orignal_price"> $ 425.00 </span>
                    <span className="discount">40% OFF</span>
                  </p>
                  <p className="hike">
                    <span className="inter">
                      <img src={others.src} alt="hike" /> Interest
                    </span>
                    <span className="incris">
                      <img src={aroww.src} alt="incris" /> 200%
                    </span>
                  </p>
                  <div className="rating">
                    <span className="rating_point">4.8</span>
                    <div className="stars">
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                    </div>
                    <span className="num">(437)</span>
                  </div>
                  <button className="buy_btn" onClick={handleRedirect}>
                    Buy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </AosAnimation>
      ) : (
        <>
          <AosAnimation animationType="fade-up" duration={1500} delay={100}>
            <div className="card_col">
              <div className="cardcover">
                <div className="card_top">
                  <img src={prd?.product_data?.images[0]?.src} alt="card_top_img" />
                </div>
                <div className="card_bottom">
                  <div className="card_bottom_cover">
                    <h4>Plain And Check Shirts</h4>
                    <p className="amount">
                      <span className="price">$245</span>
                      <span className="orignal_price"> $ 425.00 </span>
                      <span className="discount">40% OFF</span>
                    </p>
                    <p className="hike">
                      <span className="inter">
                        <img src={others.src} alt="hike" /> Interest
                      </span>
                      <span className="incris">
                        <img src={aroww.src} alt="incris" /> 200%
                      </span>
                    </p>
                    <div className="rating">
                      <span className="rating_point">4.8</span>
                      <div className="stars">
                        <img src={star.src} alt="star" />
                        <img src={star.src} alt="star" />
                        <img src={star.src} alt="star" />
                        <img src={star.src} alt="star" />
                        <img src={star.src} alt="star" />
                      </div>
                      <span className="num">(437)</span>
                    </div>
                    <button className="buy_btn" onClick={handleRedirect}>
                      Buy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </AosAnimation>
        </>
      )}
    </React.Fragment>
  )
})}
</Slider> */ }
// EXTERNAL MODULE: ./src/Helpers/Json/WomanCategoryList.ts
var WomanCategoryList = __webpack_require__(76354);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenCategorySections/WomenFindYourStyle.tsx
// @ts-nocheck










function WomenFindYourStyle() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var MobilefindYourStyle = {
        className: "center",
        centerMode: false,
        infinite: false,
        slidesToShow: 5,
        speed: 500,
        rows: 2,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AosAnimation/* default */.Z, {
        animationType: "fade-up",
        duration: 800,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "section_5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AosAnimation/* default */.Z, {
                            animationType: "fade-up",
                            duration: 1000,
                            delay: 100,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "section_5_head",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Find Your Style"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: {
                                            pathname: "/fashion/women",
                                            query: {
                                                type: "style"
                                            }
                                        },
                                        scroll: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "See More"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "your_styles_block",
                            children: [
                                WomanCategoryList/* WOMEN_FIND_YOUR_STYLE.map */.HA.map(function(style, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: {
                                                pathname: "/fashion/women",
                                                query: {
                                                    type: "style",
                                                    detail: style.name
                                                }
                                            },
                                            scroll: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "round img_cover_".concat(i + 1),
                                                onClick: function() {
                                                    dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                                        modal: "womenStyleDetails",
                                                        isOpen: true,
                                                        id: style === null || style === void 0 ? void 0 : style.name
                                                    }));
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "img_wrapper",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: style.image,
                                                            alt: "img_style".concat(i + 1)
                                                        }),
                                                        style.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "layer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: style.name
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, i);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dots dots1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dots dots2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dots dots3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dots dots4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dots dots5"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mobile_view_section_5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "section_5_heading",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Find Your Style"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: "/fashion/women",
                                    query: {
                                        type: "style"
                                    }
                                },
                                scroll: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mobile_view_seeMore",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "See More"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile_view_find_your_style_section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, MobilefindYourStyle), {
                            children: WomanCategoryList/* WOMEN_FIND_YOUR_STYLE.map */.HA.map(function(style, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: {
                                            pathname: "/fashion/women",
                                            query: {
                                                type: "style",
                                                detail: style.name
                                            }
                                        },
                                        scroll: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mobile_view_find_your_style_gridItem",
                                            onClick: function() {
                                                dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                                    modal: "womenStyleDetails",
                                                    isOpen: true,
                                                    id: style === null || style === void 0 ? void 0 : style.name
                                                }));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mobile_view_find_your_style_box_alignment",
                                                style: {
                                                    backgroundColor: style.color
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mobile-view_fashion-img-alignment",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: style.image,
                                                            alt: "bgImg"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mobile-view_fashion-option-name-alignment",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: style.name
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                }, i);
                            })
                        }))
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./src/graphql/mutations/followStore.ts
var mutations_followStore = __webpack_require__(28387);
// EXTERNAL MODULE: ./src/graphql/mutations/unFollowStore.ts
var unFollowStore = __webpack_require__(98932);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 1 modules
var notification = __webpack_require__(13448);
// EXTERNAL MODULE: ./src/components/StoreAndProductDetailModal/StoresModal/NewStoreSlider/index.tsx + 1 modules
var NewStoreSlider = __webpack_require__(96601);
// EXTERNAL MODULE: ./src/store/slices/fetchAllStoresSlice.tsx
var fetchAllStoresSlice = __webpack_require__(29494);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenCategorySections/WomenTradingStore.tsx
// @ts-nocheck


















var WomenTradingStore_SampleNextArrow = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "slick-arrow slick-next",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "6",
            height: "12",
            viewBox: "0 0 6 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 1L1 6L5 11",
                stroke: "#1E2432",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var WomenTradingStore_SamplePrevArrow = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "slick-arrow slick-prev",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "6",
            height: "12",
            viewBox: "0 0 6 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 1L1 6L5 11",
                stroke: "#1E2432",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
function WomenTradingStore() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var user = (0,auth/* useAuth */.a)().user;
    var categoryStore = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.storesData) === null || ref === void 0 ? void 0 : ref.categoryStore;
    });
    (0,react.useEffect)(function() {
        dispatch((0,fetchAllStoresSlice/* fetchStoreByCategory */.ot)({
            category_id: [
                35
            ],
            subCategory_id: [
                18
            ],
            page: 1,
            limit: 10
        }));
    }, []);
    var trendingStore = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
        pauseOnHover: true,
        lazyLoad: true,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenTradingStore_SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenTradingStore_SamplePrevArrow, {}),
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    pauseOnHover: true,
                    lazyLoad: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    pauseOnHover: true,
                    lazyLoad: true
                }
            },
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    pauseOnHover: true,
                    lazyLoad: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    pauseOnHover: true,
                    lazyLoad: true,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    pauseOnHover: true,
                    lazyLoad: true,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    pauseOnHover: true,
                    lazyLoad: true,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    infinite: false,
                    dots: false,
                    slidesToScroll: 1,
                    pauseOnHover: true,
                    lazyLoad: true
                }
            },
            {
                breakpoint: 300,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    infinite: false,
                    dots: false,
                    pauseOnHover: true,
                    lazyLoad: true
                }
            }, 
        ]
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_followStore/* default */.Z, {
        onCompleted: function(res) {
            dispatch((0,fetchAllStoresSlice/* fetchStoreByCategory */.ot)({
                category_id: [
                    35
                ],
                subCategory_id: [
                    18
                ],
                page: 1,
                limit: 10
            }));
        // setTimeout(() => {
        //   storeSearch.refetch()
        // }, 1000)
        },
        onError: function(err) {
            notification/* default.error */.Z.error({
                message: "Error",
                description: "Something went wrong"
            });
        }
    }), 1), followStore = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(unFollowStore/* default */.Z, {
        onCompleted: function(res) {
            dispatch((0,fetchAllStoresSlice/* fetchStoreByCategory */.ot)({
                category_id: [
                    35
                ],
                subCategory_id: [
                    18
                ],
                page: 1,
                limit: 10
            }));
        // setTimeout(() => {
        //   storeSearch.refetch()
        // }, 1000)
        },
        onError: function(err) {
            notification/* default.error */.Z.error({
                message: "Error",
                description: "Something went wrong"
            });
        }
    }), 1), unfollowStore = ref1[0];
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    var followStoreCall = function(store) {
        if (user) {
            followStore({
                variables: {
                    store_id: store.id
                }
            });
        } else {
            handleRedirect();
        }
    };
    var unfollowStoreCall = function(store) {
        if (user) {
            unfollowStore({
                variables: {
                    storeId: store.id
                }
            });
        } else {
            handleRedirect();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (categoryStore === null || categoryStore === void 0 ? void 0 : categoryStore.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AosAnimation/* default */.Z, {
            animationType: "fade-up",
            duration: 800,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "section_6_heading",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Trending Stores"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: {
                                pathname: "/fashion/women",
                                query: {
                                    type: "store"
                                }
                            },
                            scroll: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile_view_seeMore",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "See More"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "section_6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row section_3_row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "left_block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "left_cover",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Trending Store"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: {
                                                    pathname: "/fashion/women",
                                                    query: {
                                                        type: "store"
                                                    }
                                                },
                                                scroll: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Explore More"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "right_block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "right_block_cover",
                                        children: (categoryStore === null || categoryStore === void 0 ? void 0 : categoryStore.length) > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Trending_Store_slider",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trendingStore), {
                                                children: categoryStore === null || categoryStore === void 0 ? void 0 : categoryStore.map(function(store, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewStoreSlider/* default */.Z, {
                                                            store: store,
                                                            followStoreCall: followStoreCall,
                                                            unfollowStoreCall: unfollowStoreCall,
                                                            handleAddStoreLike: function() {}
                                                        })
                                                    }, index);
                                                })
                                            }))
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Trending_Store_slider",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "trending_store_grid",
                                                children: categoryStore === null || categoryStore === void 0 ? void 0 : categoryStore.map(function(store, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewStoreSlider/* default */.Z, {
                                                            store: store,
                                                            followStoreCall: followStoreCall,
                                                            unfollowStoreCall: unfollowStoreCall,
                                                            handleAddStoreLike: function() {}
                                                        })
                                                    }, index);
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/StoreAndProductDetailModal/ClubModal/ClubSlider/index.tsx
var ClubSlider = __webpack_require__(14333);
// EXTERNAL MODULE: ./src/store/slices/fetchAllClubsSlice.tsx + 1 modules
var fetchAllClubsSlice = __webpack_require__(15438);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenCategorySections/WomenFashionGroup.tsx
// @ts-nocheck













var WomenFashionGroup_SampleNextArrow = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "slick-arrow slick-next",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "6",
            height: "12",
            viewBox: "0 0 6 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 1L1 6L5 11",
                stroke: "#1E2432",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var WomenFashionGroup_SamplePrevArrow = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "slick-arrow slick-prev",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "6",
            height: "12",
            viewBox: "0 0 6 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 1L1 6L5 11",
                stroke: "#1E2432",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
function WomenFashionGroup(props) {
    var user = (0,auth/* useAuth */.a)().user;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var allManageClub = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.clubData) === null || ref === void 0 ? void 0 : ref.manageClubs;
    });
    var settings_Slider4 = {
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 2.5,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 10000,
        pauseOnHover: true,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenFashionGroup_SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenFashionGroup_SamplePrevArrow, {}),
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.03,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.02,
                    slidesToScroll: 1
                }
            }, 
        ]
    };
    var leaveClubYouManageCall = function(club) {
        if (user) {} else {
            handleRedirect();
        }
    };
    var joingroupCall = function(club) {
        if (user) {} else {
            handleRedirect();
        }
    };
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    (0,react.useEffect)(function() {
        dispatch((0,fetchAllClubsSlice/* fetchManageClubsData */.mG)({
            page: 1,
            limit: 100,
            type: "SUGGESTED_CLUBS"
        }));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: (allManageClub === null || allManageClub === void 0 ? void 0 : allManageClub.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AosAnimation/* default */.Z, {
            animationType: "fade-up",
            duration: 900,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "section_7_heading",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Fashion Club"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: {
                                pathname: "/fashion/women",
                                query: {
                                    type: "club"
                                }
                            },
                            scroll: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile_view_seeMore",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "See More"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "section_7",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row section_3_row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "left_block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "left_cover",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                children: [
                                                    "Fashion ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " Club"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: {
                                                    pathname: "/fashion/women",
                                                    query: {
                                                        type: "club"
                                                    }
                                                },
                                                scroll: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Explore More"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "right_block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "right_block_cover",
                                        children: (allManageClub === null || allManageClub === void 0 ? void 0 : allManageClub.length) > 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Fashion_Group_slider",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings_Slider4), {
                                                children: allManageClub === null || allManageClub === void 0 ? void 0 : allManageClub.map(function(club, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClubSlider/* default */.Z, {
                                                            club: club,
                                                            leaveGroupCall: leaveClubYouManageCall,
                                                            joingroupCall: joingroupCall,
                                                            isOpen: true
                                                        })
                                                    }, index);
                                                })
                                            }))
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "Fashion_Group_slider",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "fashion-group-slider-grid",
                                                    children: allManageClub === null || allManageClub === void 0 ? void 0 : allManageClub.map(function(club, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClubSlider/* default */.Z, {
                                                                club: club,
                                                                leaveGroupCall: leaveClubYouManageCall,
                                                                joingroupCall: joingroupCall,
                                                                isOpen: true
                                                            })
                                                        }, index);
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        }) : ""
    });
}

;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/background.png
/* harmony default export */ var background = ({"src":"/_next/static/media/background.85176c68.png","height":1141,"width":1439,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAIAAABxZ0isAAAAYElEQVR42kXCMQ4BQRQA0Dm082icQ6VWiZJKCJIRNobdmXlfI9mXl0TooSFMH4+T102rSeHQbZsrZXDeux/VMbmwqhajTVMm76w89ZZk1s2y2nU1xH/SwkDmi1kSYQ7AD3njixPMjzaaAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/e1.png
/* harmony default export */ var e1 = ({"src":"/_next/static/media/e1.59bd03e0.png","height":73,"width":73,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+AdmkRwAFBgMs+foBmPr6/DcHBQH/9vX5xPr5+Wb9+fncAdGaPCz7/wfEu8fgD8vO8QBgVSYAIBgHAPLu8un++vs6AdGbPsTi6AE7zNke++/y5gXg0tUAdmkf+v/59Qb69vy2Ac+YP/vj7f4EAQhFABEI/wBccosAimcgABkL/QDz8PfxAc2YQPrz9gMFx7T1ACMtHwDxtMEACh4CABEkBgD7+vvwAcmUO74RFhpB7fD8+vbJ4AYZtukAxef2+gA8AAYUHgmwAciPLyQSHibEDBMUF+6t0wD6k9MA2iMIAM/18uFMNg47AdSnTQAEAwQiBAgLk++l0jv/qef/5iQDv1Dc6W1tNAvlcGmCPPC6A/QAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/e2.png
/* harmony default export */ var e2 = ({"src":"/_next/static/media/e2.17f94c4f.png","height":111,"width":111,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABBklEQVR42mMAATMVWRVHI43d2gwM35pj3L92pwXuAAorgiWlmZlUdBWlX1kpC/yf1lD0/+DKWf+X1Wf8T7BReQaUVmBQEuLfxcrA8D/R1fznqonN/9dPavpfHer0M9RI9j8nG9tmBh2gsWEOpv+78xP/TyhO+z+7PPV/VaTX/6JAu/82SgIfGcQZGL5mBjr/P7Zt1f+jG5b+n1ma/H9dV/n/mSVx/zWZGT4wsEnKbFfkZPi/ddGkn7sWTP5f52zyf3Z+xM9iP/P/DAwMGxjsTfQUgIyn5ekR/1d1lP9vC3D9X+ln8j/AVOUhg6i5DAMUyBtoqWxa0lf7YXVPxftcD931QDGwJABHSGceoo4nVQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/e3.png
/* harmony default export */ var e3 = ({"src":"/_next/static/media/e3.c44d7412.png","height":185,"width":186,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA8ElEQVR42hWMP0vDUBTF72dR080P5OBXEOyiCIKCi13cnf0DKTZ0kJi0tSgdBHEQilIrSERETU3z7ovJe3E4vW84XO75/TgEgPI8b0iGRfFnWWurlBpIPMcc9CSpYsbne4LfNIXWGiJ8y112Qs/BLMtsu7WLu/4VSmPcCpg5dELJ8lSFxvFOE3Gnjf+6hutE0qREmOVzBG8J9nwfh2EEf/qKuXSsWJMtq95o/AgKLux6MkH884GDoGPvn8aoKxMSAO8sDlM62sdJ8oJpNsNpdInuzfALwJITaHVro7HZ9a9vJ89mMHowrfOo39xeWwFACzU70r3mZxv8AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./public/assets/img/WomansCategory/e4.png
var e4 = __webpack_require__(71540);
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/e5.png
/* harmony default export */ var e5 = ({"src":"/_next/static/media/e5.27922650.png","height":220,"width":220,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA/ElEQVR42h2NPUvDUABF368pob/NQRyUgpMoCq2IGJWKg4KDEaOVaNHBxgYUQdps1hJSlXwpNd9Jm5cO1/c63nsOHAKAJJeN6sx913RVmUn79TIf6d2yfShwRoq7g2piD4I09lBbWkBzrYbQt5A5A3/a2hVIavY0Dn+sId1cXUbv5RHT7JdGXDL7KkmcjzKNXS6gJZ3h+ekeOdtRYIExOheiwEYWuWjfXOD0WEQa2ojZx1jBEv1uHDqI/r6pciXh5EhEOP6i/GP5DsnkujDxDH9k6miK69jb3oLnGMjd4XgiNyoEAIF+Kxiaoso7K8X5xmLx+frQwdt1BQD5ByxRzuvpSNEwAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/e6.png
/* harmony default export */ var e6 = ({"src":"/_next/static/media/e6.ab950ced.png","height":169,"width":169,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABAElEQVR42mMAAW1tDS0GUfFDDFy8v2TlpH8pKivsl1OQVYNI6htoymhovYvwcfwfaKXzHyj0X1JG6r+SmsprBRUlFQYRdZ2D/oE+/2e2lv6ckBf1X1OG97+EhPBPBVXV/0qamrsYZA2Nf0aFeP5f3FH6PzvC77+6vMB/dWWZ//Ka2v+VdfW/MMjp6//IiPH+v6av4n+IoznYCltjtf/q+nr/lQ1NvjBoW5juSY/x+l8V5/LTSln0PwMj838rAyWgFSpABcZbGTx93VSU1BVfeBjI/HfTlf1vJCf8X4Cb7T+fkMATJW1teQYoUGJgYd+uLS30WU9K4BMTC8sWoBhYEgAmz1HlrZeeIAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/e7.png
/* harmony default export */ var e7 = ({"src":"/_next/static/media/e7.895df49c.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+ASYlJwAlMzEe2djYkRIfFz3n8/P/JREZvCUnI2/v5ezqAS43NSEEBwrEBAwGGkQtLwAcCREAnbmwABIdH9ssJC88AS0/P7kiHhxGsc3P+qRjaAUtJCUAkZ2a+7Hj5AYoDwyoATZERPcTDw8It62tAI10dwA0JicAiZ+e/8r1+gErHhjsAThGSPkD//0GDBomAFQyLQAtDwUAjrG4/6q9yQEvKBztARkrJsBDRFQ/P0ZR+g7//AYpEQ0AmcbK+qeQhwb27++wAQAAAClUeYrFMCcqEQH+/gD67egAAxUbAKeaj+XXxrw6AQAkOwAAQkMpfDErl+zu7TjIxsH/SE5VwtDW1Wf78vDgpuZnXoiVCcYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/e8.png
/* harmony default export */ var e8 = ({"src":"/_next/static/media/e8.fe7db283.png","height":132,"width":132,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+AdezeQDXyaoemardlbnaAD8MDQ4ALRj+xD0xFGs1JwvfAf//xh6pjpjFwMz6HEAvJQCooYYAsNcCAIRfGehTPxc7Aa6HSrLC0N1NMTNe+jksJwavpZ0AoLrT+lJC/gY7LhK6AcCYVPCRkKwPLh42ADY6PAD2+/0AuL67AO/+5QBjTyD3AffgtPHi7QAOybGuAODIygALGR0ArcTTAEM3/AA/Mhv3AfPft7MMHjZM9PHz+sqzrQbDqZMAChgk+isj7gYBAv28Af/rox+prdbG4u4NGmZPQwDOvrgAyMnHAAUH8Oo3L/U7AYBnAACAmQAggnVylmtpZz7T0M8BaVJYxNcAI2p9Xd3d1th4v/OWQF8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/e9.png
/* harmony default export */ var e9 = ({"src":"/_next/static/media/e9.2ef7e959.png","height":98,"width":98,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA/klEQVR42g3Ju0rDYBgG4Pf7cughHrDt0GgbaAcHN9FNJwVXixciiFeiEO/CxcXBQQoadFRHwcEDQREhTZOYPz//1/KMDwHA6Wjfv3mIzk8OD/b6az0Kw3BcDreOAXzYALpXj8/3nVptUK/ZaNiEtu+Nrl+etr8ya9fuNNyz1zgZtFpKxZ/vjltpyisoo3QPYi4IZP9urHB70zdSzjPLCMYlpP+MKDZTG2IoWCZYzGCnjqC7iLTMoXSB4YIQLzkynpSCTKHSWpAUOUS0EmE0HdxR4FGv3eTIc6nvOQQiAc0VGt8/abVjJRUmfpMvU4X1v9ysWgw1LeWWGUcNl99mlSVqK6L45XwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/img/WomansCategory/e10.png
/* harmony default export */ var e10 = ({"src":"/_next/static/media/e10.b89cf488.png","height":122,"width":122,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABCElEQVR42g2NO0vDUABGv3tz702lwT60oQ1RByldHZUQOwr+E6V/px1cdBJBiw5OdVPTuokoCIJvQyn4aBrzxDTmcLYzHIIM66y3qMwq7Zvbu2ZiP2B5Ze0iry21ADyzQRZ5TlhhFOmT+ys0SgLO12hTLlf63u/YoClFm3OhB74f5/9cTAJALqkxSadVJnIdKjFp3XVd7B8cid71KwqrG5irqCJJEoAQkzLGidUfYGdvF0+ejM/vMRhjSNMUyKQAzv0wBEExjkIP3eNTeNmOShJAYNFGvd6aJslQphCqOo/Dky5seyg45yM/iLeYotZeCrxsVPVi58dxTGWmRt7ePy6bprG9oGmP/6XTaSuR027VAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/graphql/mutations/sendFriendRequest.ts
var mutations_sendFriendRequest = __webpack_require__(14118);
// EXTERNAL MODULE: ./src/graphql/mutations/declineFriendRequest.ts
var mutations_declineFriendRequest = __webpack_require__(78008);
// EXTERNAL MODULE: ./src/components/StoreAndProductDetailModal/PeopleModal/PeopleItem/index.tsx
var PeopleItem = __webpack_require__(7799);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenCategorySections/WomanFashionEnthusiasts.tsx
// @ts-nocheck





























function WomanFashionEnthusiasts() {
    var ref;
    var Enthusiasts = [
        e1,
        e2,
        e3,
        e4/* default */.Z,
        e5,
        e6,
        e7,
        e8,
        e9,
        e10
    ];
    var user = (0,auth/* useAuth */.a)().user;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var peopleData = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.peopleData;
    });
    var ref1 = (0,react.useState)(1), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,react.useState)(15), limit = ref2[0], setLimit = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_sendFriendRequest/* default */.Z, {
        onCompleted: function() {
            dispatch((0,fetchAllPeopleSlice/* fetchAllPeople */.v)({
                limit: limit,
                page: page,
                type: "ALL_PEOPLE",
                prevPost: []
            }));
        },
        onError: function(error) {
            console.log(error);
        }
    }), 1), sendFriendRequest = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_declineFriendRequest/* default */.Z, {
        onCompleted: function() {
            dispatch((0,fetchAllPeopleSlice/* fetchAllPeople */.v)({
                limit: limit,
                page: page,
                type: "ALL_PEOPLE",
                prevPost: []
            }));
        },
        onError: function(error) {
            return console.log(error);
        }
    }), 1), declineFriendRequest = ref4[0];
    var declineFriendRequestCall = function(people) {
        if (user) {
            declineFriendRequest({
                variables: {
                    user_id: user === null || user === void 0 ? void 0 : user.id,
                    friend_id: people === null || people === void 0 ? void 0 : people.id
                }
            });
        } else {
            handleRedirect();
        }
    };
    var sendFriendRequestCall = function(people) {
        if (user) {
            sendFriendRequest({
                variables: {
                    friend_id: people === null || people === void 0 ? void 0 : people.id,
                    user_id: user === null || user === void 0 ? void 0 : user.id,
                    isActive: true,
                    isFriend: true
                }
            });
        } else {
            handleRedirect();
        }
    };
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1.5,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1.5
                }
            }, 
        ]
    };
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AosAnimation/* default */.Z, {
            animationType: "fade-up",
            duration: 1000,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "section_8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "background",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: background.src,
                                alt: "background"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "subsection_1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AosAnimation/* default */.Z, {
                                        animationType: "fade-up",
                                        duration: 1000,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "section_5_head",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Woman Fashion Enthusiasts"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Find out women fashion inspiration from creative people around the globe"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/fashion/women",
                                                        query: {
                                                            type: "influencers"
                                                        }
                                                    },
                                                    scroll: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: "See More"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "Enthusiasts_block",
                                        children: [
                                            Enthusiasts.map(function(Data, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "round round".concat(i + 1),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "parent",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "round_card",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: "Annette Black"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                        children: "Photographer"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "1k Followers"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "btn_block",
                                                                        onClick: handleRedirect,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            children: "Follow"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: Data.src,
                                                            alt: "round1"
                                                        })
                                                    ]
                                                }, i);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "dots dots1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "dots dots2"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "dots dots3"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "dots dots4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "dots dots5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "dots dots6"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "mobile-view-section-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "section_8_heading",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Woman Fashion Influencers"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: {
                                        pathname: "/fashion/women",
                                        query: {
                                            type: "influencers"
                                        }
                                    },
                                    scroll: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mobile_view_seeMore",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "See More"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "section_8_details-alignment",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "section_8_details-flex-alignment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                                    children: peopleData === null || peopleData === void 0 ? void 0 : (ref = peopleData.allPeople) === null || ref === void 0 ? void 0 : ref.map(function(people, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleItem/* default */.Z, {
                                            people: people,
                                            declineFriendRequestCall: declineFriendRequestCall,
                                            sendFriendRequestCall: sendFriendRequestCall
                                        });
                                    })
                                }))
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WebCategoryMain.tsx











function WebCategoryMain() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenBannerSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopCardSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopByWomenCategory, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenTredingSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenFindYourStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenTradingStore, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenFashionGroup, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WomanFashionEnthusiasts, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/index.tsx




function WomansCategory(props) {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-women-category-header-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mobile-women-category-back-alignment",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "back_details-alignment",
                            onClick: function() {
                                return router.push("/feed");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/icon/left-icon.svg",
                                        alt: "back-page"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Back"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-heading-alignment",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Woman Fashion &..."
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "WomansCategory_page",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebCategoryMain, {})
            })
        ]
    });
}

;// CONCATENATED MODULE: ./public/assets/img/bannerBg.svg
/* harmony default export */ var bannerBg = ({"src":"/_next/static/media/bannerBg.24aaf797.svg","height":178,"width":1440});
;// CONCATENATED MODULE: ./public/assets/img/mobileTradendingBg.png
/* harmony default export */ var mobileTradendingBg = ({"src":"/_next/static/media/mobileTradendingBg.497741ce.png","height":100,"width":375,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAMklEQVR42mP4AQY/f/4Ekp8+fvz0+P61wwc3TJvDAJf4/v3758+fX7x4dunEyY1TZwEATywq2oKTiJUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./src/components/Category/CategoryComman/TrendingProductCommon/index.tsx
var TrendingProductCommon = __webpack_require__(20774);
// EXTERNAL MODULE: ./src/store/slices/fetchAllProduct.tsx
var fetchAllProduct = __webpack_require__(87789);
;// CONCATENATED MODULE: ./src/components/Category/CategoryComman/TrendingProducts/index.tsx

















function TrendingProducts(props) {
    var ref, ref1, ref2;
    var PageDataFun = props.PageDataFun;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref3 = (0,react.useState)(0), scrollY = ref3[0], setScrollY = ref3[1];
    var ref4 = (0,react.useState)(1), page = ref4[0], setPage = ref4[1];
    var ref5 = (0,react.useState)(30), dataLimite = ref5[0], setDataLimite = ref5[1];
    var ref6 = (0,react.useState)([]), productData = ref6[0], setProductData = ref6[1];
    var ref7 = (0,react.useState)([]), data = ref7[0], setData = ref7[1];
    var productByCategory = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.productByCategory;
    });
    var newarray = [];
    var newData = (productByCategory === null || productByCategory === void 0 ? void 0 : (ref = productByCategory.product) === null || ref === void 0 ? void 0 : (ref1 = ref.getAllProducts) === null || ref1 === void 0 ? void 0 : ref1.data) || [];
    newarray.push(newData);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        dispatch((0,fetchAllProduct/* fetchProductByCategory */.h4)({
            category: "fashion-and-accessories",
            subCategory: (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("women")) ? "women" : "men",
            childSubCategory: (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.category) ? router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.category : "",
            isShopifyProduct: false,
            page: page,
            limit: dataLimite,
            order: "like_count"
        }));
        if ((productByCategory === null || productByCategory === void 0 ? void 0 : (ref3 = productByCategory.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.getAllProducts) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.length) > 0) {
            var ref6, ref7, ref8, ref9;
            var products = [];
            productByCategory === null || productByCategory === void 0 ? void 0 : (ref6 = productByCategory.product) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.getAllProducts) === null || ref7 === void 0 ? void 0 : ref7.data.map(function(data, i) {
                products.push((0,_object_spread/* default */.Z)({
                    index: i
                }, data));
            });
            setData((0,_to_consumable_array/* default */.Z)(data).concat((0,_to_consumable_array/* default */.Z)(productByCategory === null || productByCategory === void 0 ? void 0 : (ref8 = productByCategory.product) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.getAllProducts) === null || ref9 === void 0 ? void 0 : ref9.data)));
        }
    }, [
        page
    ]);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            if (page >= 0 && page < 10) {
                setPage(function(prevPage) {
                    return prevPage + 1;
                }) // Increment page
                ;
            }
        }, 3000);
        return function() {
            return clearTimeout(timer) // Cleanup timeout on unmount
            ;
        };
    }, [
        page
    ]);
    var Cards = (data === null || data === void 0 ? void 0 : data.length) > 0 ? (ref2 = (0,_to_consumable_array/* default */.Z)(Array(Math.floor(Number((data === null || data === void 0 ? void 0 : data.length) / 12))))) === null || ref2 === void 0 ? void 0 : ref2.map(function(prodcut, i) {
        return [
            {
                img: null,
                type: null,
                parent_fill: true,
                child: [
                    {
                        img: s1,
                        type: "small",
                        product: true
                    },
                    {
                        img: s2,
                        type: "small",
                        product: true
                    }, 
                ]
            },
            {
                img: s4,
                type: "large",
                parent_fill: false,
                product: true,
                child: []
            },
            {
                img: null,
                type: null,
                parent_fill: true,
                child: [
                    {
                        img: s2,
                        type: "small",
                        product: true
                    },
                    {
                        img: s1,
                        type: "small",
                        product: true
                    }, 
                ]
            },
            {
                img: s4,
                type: "large",
                parent_fill: false,
                product: true,
                child: []
            },
            {
                img: s3,
                type: "large",
                parent_fill: false,
                product: true,
                child: []
            },
            {
                img: null,
                type: null,
                parent_fill: true,
                child: [
                    {
                        img: s1,
                        type: "small",
                        product: true
                    },
                    {
                        img: s2,
                        type: "small",
                        product: true
                    }, 
                ]
            },
            {
                img: s4,
                type: "large",
                parent_fill: false,
                product: true,
                child: []
            },
            {
                img: null,
                type: null,
                parent_fill: true,
                child: [
                    {
                        img: s1,
                        type: "small",
                        product: true
                    },
                    {
                        img: s2,
                        type: "small",
                        product: true
                    }, 
                ]
            }, 
        ];
    }).flat() : [];
    (0,react.useEffect)(function() {
        if (Cards.length > 0) {
            var i = 0;
            var result = Cards.map(function(card, index) {
                // if (data[i]) {
                if (card.product && !card.parent_fill && data[i]) {
                    card.product_data = data[i];
                    i++;
                }
                if (card.child && card.parent_fill && data[i]) {
                    card.child = card.child.map(function(child, ind) {
                        if (child.product) {
                            child.product_data = data[i];
                            i++;
                        }
                        return child;
                    });
                }
                return card;
            // }
            });
            setProductData(result);
        }
    }, [
        Cards.length
    ]);
    (0,react.useEffect)(function() {
        var onScroll = function() {
            var scrolling = window.scrollY;
            setScrollY(scrolling);
        };
        window.addEventListener("scroll", onScroll);
        return function() {
            return window.removeEventListener("scroll", onScroll);
        };
    }, [
        scrollY
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "trendingProducts-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "trending-back-alignment",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "back_details-alignment",
                        onClick: function() {
                            router.push("/fashion/women/", undefined, {
                                scroll: false
                            });
                            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                modal: "",
                                isOpen: false,
                                id: 0
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icon/left-icon.svg",
                                    alt: "back-page"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Woma..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: scrollY > 50 ? "mobile-heading-alignment" : "mobile-heading-alignment-none",
                        "data-show": scrollY > 50 ? true : false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Now Trending"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "trendingProduct-banner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "trending-banner-img-alignment",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: bannerBg.src,
                                alt: "TrendingProductBanner"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-show": scrollY > 50 ? false : true,
                                className: "lgviewstickyheader",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: mobileTradendingBg.src,
                                    alt: "MobileTrendingProductBanner",
                                    className: "mobile-view-banner"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-show": scrollY > 50 ? false : true,
                        className: "lgviewstickyheader",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "trendingProduct-banner-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "left-arrow-alignment",
                                        onClick: function() {
                                            router.push("/fashion/women/", undefined, {
                                                scroll: false
                                            });
                                            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                                modal: "",
                                                isOpen: false,
                                                id: 0
                                            }));
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/icon/leftArrow.svg",
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "trending-heading-alignment",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: "Trending Product"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: WomanCategoryList/* WOMEN_SECTION_TEXT.now_trending.text */.hR.now_trending.text
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "trendingImg-gallery-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "trending_product_block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingProductCommon/* default */.Z, {
                            Cards: productData
                        })
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/FindYourStyle/FindYourStyleMainSection/FindYourStyleMobile/index.tsx



function FindYourStyleMobile(param) {
    var setsubPage = param.setsubPage, Cards = param.Cards, selectedStyle = param.selectedStyle;
    var ref = (0,react.useState)(false), MobileviewSidebar = ref[0], setMobileviewSidebar = ref[1];
    var ref1 = (0,react.useState)((selectedStyle === null || selectedStyle === void 0 ? void 0 : selectedStyle.name) ? selectedStyle === null || selectedStyle === void 0 ? void 0 : selectedStyle.name : WomanCategoryList/* WOMEN_FIND_YOUR_STYLE.0.name */.HA[0].name), styleName = ref1[0], setStyleName = ref1[1];
    var hanleSelect = function(style) {
        setStyleName(style.name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "women-mobile-view-details-fashion-name-search-alignment",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "width-alignment",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mobile-view-sidebar-alignment",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-search-sidebar-details-box-alignment",
                            children: MobileviewSidebar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-view-sidebar-box-alignment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mobile-silder-side-main-details",
                                    children: WomanCategoryList/* WOMEN_FIND_YOUR_STYLE.map */.HA.map(function(style, index) {
                                        return(// <div className="find-fashion-border-alignment find-fashion-border-active">
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "find-fashion-border-alignment",
                                            onClick: function() {
                                                return hanleSelect(style);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-fashion-box-alignment",
                                                style: {
                                                    backgroundColor: style.color
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "fashion-img-alignment",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: style === null || style === void 0 ? void 0 : style.image,
                                                            alt: "bgImg"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "fashion-option-name-alignment",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: style === null || style === void 0 ? void 0 : style.name
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }, "y".concat(index + 1)));
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "width-alignment",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mobile-view-child-heading-alignment",
                                    style: MobileviewSidebar ? {
                                        gap: 55
                                    } : {
                                        justifyContent: "space-between"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mobile-view-child-name-alignment",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                children: styleName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "(654 item)"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "women-mobile-findYourStyle_product_block_empty_state",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/img/emptystateimage/emptystateimage2.png",
                                                alt: "Emptystateimage2"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Not Found :("
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/FindYourStyle/FindYourStyleMainSection/FindYourStyleWeb/index.tsx







// import Emptystateimage from "/assets/img/bannerBg.svg";
// import Emptystateimage from "/public/assets/img/emptystateimage/emptystateimage.png";
function FindYourStyleWeb(param) {
    var setsubPage = param.setsubPage, Cards = param.Cards, setMenStyleData = param.setMenStyleData, PageDataFun = param.PageDataFun;
    // const [search, setSearch] = useState('')
    var user = (0,auth/* useAuth */.a)().user;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "findYourStyles-styles-details-alignment",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: WomanCategoryList/* WOMEN_FIND_YOUR_STYLE.map */.HA.map(function(style, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "child-styles-details",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "details-heading-alignment third-product",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "find-your-style-bg-img",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: style === null || style === void 0 ? void 0 : style.bannerImage,
                                            alt: "FindStyleDemoImg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "fashion-name-alignment",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                children: style === null || style === void 0 ? void 0 : style.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: style === null || style === void 0 ? void 0 : style.text
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: {
                                            pathname: "/fashion/women",
                                            query: {
                                                type: "style",
                                                detail: style === null || style === void 0 ? void 0 : style.name
                                            }
                                        },
                                        scroll: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "see-all-product-alignment",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    "See All ",
                                                    style === null || style === void 0 ? void 0 : style.name,
                                                    " Style ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/icon/right-blue-arrow.svg"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "findYourStyle_product_block_empty",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "findYourStyle_product_block_empty_details_box",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/img/emptystateimage/emptystateimage.png",
                                                alt: "Emptystateimage"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "We don't have any style selection right now, but check back soon!"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/FindYourStyle/FindYourStyleMainSection/index.tsx














function FindYourStyleMainSection(param) {
    var PageDataFun = param.PageDataFun, setsubPage = param.setsubPage, selectedStyle = param.selectedStyle, setMenStyleData = param.setMenStyleData;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var Cards = [
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small"
                },
                {
                    img: s2,
                    type: "small"
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s2,
                    type: "small"
                },
                {
                    img: s1,
                    type: "small"
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            child: []
        },
        {
            img: s3,
            type: "large",
            parent_fill: false,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small"
                },
                {
                    img: s2,
                    type: "small"
                }, 
            ]
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "findYourStyles-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "findYourStyles-back-alignment",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "back_details-alignment",
                        onClick: function() {
                            router.push("/fashion/women/", undefined, {
                                scroll: false
                            });
                            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                modal: "",
                                isOpen: false,
                                id: 0
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icon/left-icon.svg",
                                    alt: "back-page"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Woma..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile-heading-alignment",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Find Your Style"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "findYourStyles-banner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "findYourStyles-banner-img-alignment",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: bannerBg.src,
                                alt: "FindYourStyleBanner"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: mobileTradendingBg.src,
                                alt: "MobileFindYourStyleBanner",
                                className: "mobile-view-banner"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "findYourStyles-banner-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "left-arrow-alignment",
                                    onClick: function() {
                                        router.push("/fashion/women/", undefined, {
                                            scroll: false
                                        });
                                        dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                            modal: "",
                                            isOpen: false,
                                            id: 0
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/icon/leftArrow.svg",
                                        alt: "left-arrow"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "findYourStyles-heading-alignment",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: "Find Your Style"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: WomanCategoryList/* WOMEN_SECTION_TEXT.find_your_style.text */.hR.find_your_style.text
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindYourStyleMobile, {
                setsubPage: setsubPage,
                Cards: Cards,
                selectedStyle: selectedStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindYourStyleWeb, {
                setsubPage: setsubPage,
                Cards: Cards,
                setMenStyleData: setMenStyleData,
                PageDataFun: PageDataFun
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/FindYourStyle/index.tsx



function FindYourStyle(props) {
    var PageDataFun = props.PageDataFun, viewPage = props.viewPage, selectedStyle = props.selectedStyle, setMenStyleData = props.setMenStyleData;
    var ref = (0,react.useState)("FindYourStyle"), viewsubPage = ref[0], setsubPage = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindYourStyleMainSection, {
            PageDataFun: PageDataFun,
            setsubPage: setsubPage,
            selectedStyle: selectedStyle,
            setMenStyleData: setMenStyleData
        })
    });
}

;// CONCATENATED MODULE: ./public/assets/img/enthoumBg.svg
/* harmony default export */ var enthoumBg = ({"src":"/_next/static/media/enthoumBg.b49777a8.svg","height":178,"width":1440});
;// CONCATENATED MODULE: ./public/assets/img/MobilefashionEnthem.svg
/* harmony default export */ var MobilefashionEnthem = ({"src":"/_next/static/media/MobilefashionEnthem.759ff234.svg","height":100,"width":375});
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/FashionEnthusiasts/index.tsx


















function FashionEnthusiasts(props) {
    var ref, ref1;
    var user = (0,auth/* useAuth */.a)().user;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var peopleData = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.peopleData;
    });
    var ref2 = (0,react.useState)(1), page = ref2[0], setPage = ref2[1];
    var ref3 = (0,react.useState)(15), limit = ref3[0], setLimit = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_sendFriendRequest/* default */.Z, {
        onCompleted: function() {
            dispatch((0,fetchAllPeopleSlice/* fetchAllPeople */.v)({
                limit: limit,
                page: page,
                type: "ALL_PEOPLE",
                prevPost: []
            }));
        },
        onError: function(error) {
            console.log(error);
        }
    }), 1), sendFriendRequest = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_declineFriendRequest/* default */.Z, {
        onCompleted: function() {
            dispatch((0,fetchAllPeopleSlice/* fetchAllPeople */.v)({
                limit: limit,
                page: page,
                type: "ALL_PEOPLE",
                prevPost: []
            }));
        },
        onError: function(error) {
            return console.log(error);
        }
    }), 1), declineFriendRequest = ref5[0];
    var declineFriendRequestCall = function(people) {
        if (user) {
            declineFriendRequest({
                variables: {
                    user_id: user === null || user === void 0 ? void 0 : user.id,
                    friend_id: people === null || people === void 0 ? void 0 : people.id
                }
            });
        } else {
            handleRedirect();
        }
    };
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    var sendFriendRequestCall = function(people) {
        if (user) {
            sendFriendRequest({
                variables: {
                    friend_id: people === null || people === void 0 ? void 0 : people.id,
                    user_id: user === null || user === void 0 ? void 0 : user.id,
                    isActive: true,
                    isFriend: true
                }
            });
        } else {
            handleRedirect();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fashionEnthusiasts-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fashionEnthusiasts-back-alignment",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "back_details-alignment",
                        onClick: function() {
                            router.push("/fashion/women/", undefined, {
                                scroll: false
                            });
                            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                modal: "",
                                isOpen: false,
                                id: 0
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icon/left-icon.svg",
                                    alt: "back-page"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Woma..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile-heading-alignment",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Woman Fashio..."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fashionEnthusiasts-banner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "fashionEnthusiasts-banner-img-alignment",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: enthoumBg.src,
                                alt: "FashionEnthusiastsBanner"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: MobilefashionEnthem.src,
                                alt: "MobileFashionEnthusiastsBanner",
                                className: "mobile-view-banner"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fashionEnthusiasts-banner-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "left-arrow-alignment",
                                    onClick: function() {
                                        router.push("/fashion/women/", undefined, {
                                            scroll: false
                                        });
                                        dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                            modal: "",
                                            isOpen: false,
                                            id: 0
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/icon/leftArrow.svg",
                                        alt: "left-arrow"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fashionEnthusiasts-heading-alignment",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: "Woman Fashion Influencers"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: WomanCategoryList/* WOMEN_SECTION_TEXT.men_fashion_enthusiasts.text */.hR.men_fashion_enthusiasts.text
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fashionEnthusiasts-details-list-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "suggested-frieds-all-content-alignment",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid",
                            children: (peopleData === null || peopleData === void 0 ? void 0 : peopleData.allPeople) && ((ref1 = peopleData === null || peopleData === void 0 ? void 0 : (ref = peopleData.allPeople) === null || ref === void 0 ? void 0 : ref.filter(function(usr) {
                                return usr.id !== (user === null || user === void 0 ? void 0 : user.id);
                            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(people, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AosAnimation/* default */.Z, {
                                    animationType: "fade-up",
                                    duration: 1000,
                                    delay: index * 50,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleItem/* default */.Z, {
                                        people: people,
                                        declineFriendRequestCall: declineFriendRequestCall,
                                        sendFriendRequestCall: sendFriendRequestCall
                                    })
                                });
                            }))
                        })
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/Helpers/Json/ManCategoryList.ts
var ManCategoryList = __webpack_require__(71985);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/FashionGroups/index.tsx













function FashionGroups(props) {
    var router = (0,next_router.useRouter)();
    var user = (0,auth/* useAuth */.a)().user;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var allManageClub = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.clubData) === null || ref === void 0 ? void 0 : ref.manageClubs;
    });
    var leaveClubYouManageCall = function(club) {
        if (user) {} else {
            handleRedirect();
        }
    };
    (0,react.useEffect)(function() {
        dispatch((0,fetchAllClubsSlice/* fetchManageClubsData */.mG)({
            page: 1,
            limit: 100,
            type: "SUGGESTED_CLUBS"
        }));
    }, []);
    var joingroupCall = function(club) {
        if (user) {} else {
            handleRedirect();
        }
    };
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fashionGroups-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fashionGroups-back-alignment",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "back_details-alignment",
                        onClick: function() {
                            router.push("/fashion/women/", undefined, {
                                scroll: false
                            });
                            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                modal: "",
                                isOpen: false,
                                id: 0
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icon/left-icon.svg",
                                    alt: "back-page"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Woma..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile-heading-alignment",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Now Trending"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fashionGroups-banner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "fashionGroups-banner-img-alignment",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: bannerBg.src,
                                alt: "FashionGroupBanner"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: mobileTradendingBg.src,
                                alt: "MobileFashionGroupBanner",
                                className: "mobile-view-banner"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fashionGroups-banner-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "left-arrow-alignment",
                                    onClick: function() {
                                        router.push("/fashion/women/", undefined, {
                                            scroll: false
                                        });
                                        dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                            modal: "",
                                            isOpen: false,
                                            id: 0
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/icon/leftArrow.svg",
                                        alt: "left-arrow"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fashionGroups-heading-alignment",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: "Fashion Clubs"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: ManCategoryList/* MEN_SECTION_TEXT.fashion_group.text */.Cu.fashion_group.text
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fashionGroups-details-alignment",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fashion_group_details_grid",
                        children: allManageClub === null || allManageClub === void 0 ? void 0 : allManageClub.map(function(club, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClubSlider/* default */.Z, {
                                    club: club,
                                    leaveGroupCall: leaveClubYouManageCall,
                                    joingroupCall: joingroupCall,
                                    isOpen: true
                                })
                            }, index);
                        })
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./public/assets/img/trendingStore.svg
/* harmony default export */ var trendingStore = ({"src":"/_next/static/media/trendingStore.4244dd57.svg","height":178,"width":1440});
;// CONCATENATED MODULE: ./public/assets/img/mobileTrendingStore.svg
/* harmony default export */ var mobileTrendingStore = ({"src":"/_next/static/media/mobileTrendingStore.fa93170e.svg","height":100,"width":375});
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/TrendingStore/index.tsx


















function TrendingStore(props) {
    var router = (0,next_router.useRouter)();
    var user = (0,auth/* useAuth */.a)().user;
    var categoryStore = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.storesData) === null || ref === void 0 ? void 0 : ref.categoryStore;
    });
    var dispatch = (0,store/* useAppDispatch */.T)();
    (0,react.useEffect)(function() {
        dispatch((0,fetchAllStoresSlice/* fetchStoreByCategory */.ot)({
            category_id: [
                35
            ],
            subCategory_id: [
                18
            ],
            page: 1,
            limit: 10
        }));
    }, []);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_followStore/* default */.Z, {
        onCompleted: function(res) {
            dispatch((0,fetchAllStoresSlice/* fetchStoreByCategory */.ot)({
                category_id: [
                    35
                ],
                subCategory_id: [
                    18
                ],
                page: 1,
                limit: 10
            }));
        },
        onError: function(err) {
            notification/* default.error */.Z.error({
                message: "Error",
                description: "Something went wrong"
            });
        }
    }), 1), followStore = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(unFollowStore/* default */.Z, {
        onCompleted: function(res) {
            dispatch((0,fetchAllStoresSlice/* fetchStoreByCategory */.ot)({
                category_id: [
                    35
                ],
                subCategory_id: [
                    18
                ],
                page: 1,
                limit: 10
            }));
        },
        onError: function(err) {
            notification/* default.error */.Z.error({
                message: "Error",
                description: "Something went wrong"
            });
        }
    }), 1), unfollowStore = ref1[0];
    var followStoreCall = function(store) {
        if (user) {
            followStore({
                variables: {
                    store_id: store.id
                }
            });
        } else {
            handleRedirect();
        }
    };
    var unfollowStoreCall = function(store) {
        if (user) {
            unfollowStore({
                variables: {
                    storeId: store.id
                }
            });
        } else {
            handleRedirect();
        }
    };
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    var handleAddStoreLike = function() {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "trendingStore-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "trendingStore-main-banner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "trendingStore-back-alignment",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "back_details-alignment",
                                onClick: function() {
                                    router.push("/fashion/women/", undefined, {
                                        scroll: false
                                    });
                                    dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                        modal: "",
                                        isOpen: false,
                                        id: 0
                                    }));
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/icon/left-icon.svg",
                                            alt: "back-page"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Woma..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-heading-alignment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Trending Store"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "trendingStore-banner",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "trending-banner-img-alignment",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: trendingStore.src,
                                        alt: "TrendingStoreBnner"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: mobileTrendingStore.src,
                                        alt: "MobileTrendingStoreBnner",
                                        className: "mobile-view-banner"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "trendingStore-banner-section",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "left-arrow-alignment",
                                            onClick: function() {
                                                router.push("/fashion/women/", undefined, {
                                                    scroll: false
                                                });
                                                dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                                    modal: "",
                                                    isOpen: false,
                                                    id: 0
                                                }));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icon/leftArrow.svg",
                                                alt: "left-arrow"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "trendingStore-heading-alignment",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Trending Store"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: WomanCategoryList/* WOMEN_SECTION_TEXT.trending_store.text */.hR.trending_store.text
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "trending-store-alignment",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "popularStoreDetailsGridView",
                        children: categoryStore === null || categoryStore === void 0 ? void 0 : categoryStore.map(function(store, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewStoreSlider/* default */.Z, {
                                    store: store,
                                    followStoreCall: followStoreCall,
                                    unfollowStoreCall: unfollowStoreCall,
                                    handleAddStoreLike: handleAddStoreLike
                                })
                            }, index);
                        })
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/store/slices/manageCategoryDetail.tsx
var manageCategoryDetail = __webpack_require__(71861);
// EXTERNAL MODULE: ./src/components/BookAppliance/BookApplianceModal/BookApplianceShopByCategory/CategorySmallBanner/index.tsx
var CategorySmallBanner = __webpack_require__(23433);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenPageModal/WomenCategoryModalMain/index.tsx








function WomenCategoryModalMain() {
    var modalRef = (0,react.useRef)();
    var manageApplianceCategoryModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageApplianceCategoryModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(0), scrollY = ref[0], setScrollY = ref[1];
    var handleScroll = function(event) {
        setScrollY(event.target.scrollTop);
    };
    var handleClose = function() {
        router.push("/fashion/women/", undefined, {
            scroll: false
        });
        dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
            modal: "",
            isOpen: false,
            id: 0
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: modalRef,
            onScroll: handleScroll,
            style: {
                width: "100%",
                height: "100%",
                overflow: "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySmallBanner/* default */.Z, {
                categoryData: WomanCategoryList/* WOMEN_CATEGORY */.Xy,
                scrollY: scrollY,
                handleClose: handleClose,
                pathname: "/fashion/women"
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/ProductPage/AllProduct/index.tsx + 2 modules
var AllProduct = __webpack_require__(55317);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/SubCategoryFindYourStyle/index.tsx
// @ts-nocheck















function SubCategoryFindYourStyle(props) {
    var SampleNextArrow = function SampleNextArrow(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: onClick,
            className: "slider-right-arrow-alignment",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/assets/icon/SliderRightArrow.svg"
            })
        });
    };
    var SamplePrevArrow = function SamplePrevArrow(props) {
        var className = props.className, style = props.style, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "slider-left-arrow-alignment",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/assets/icon/SliderLeftArrow.svg"
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var productByCategory = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.productByCategory;
    });
    var ref5 = (0,react.useState)({
        subCategory: [],
        category: []
    }), filterData = ref5[0], setFilterData = ref5[1];
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref6 = (0,react.useState)(1), page = ref6[0], setPage = ref6[1];
    var ref7 = (0,react.useState)(40), dataLimite = ref7[0], setDataLimite = ref7[1];
    (0,react.useEffect)(function() {
        setPage(1);
        fetchProduct();
    }, []);
    var fetchProduct = function() {
        var ref, ref1, ref2;
        dispatch((0,fetchAllProduct/* fetchProductByCategory */.h4)({
            category: "fashion-and-accessories",
            subCategory: (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("women")) ? "women" : "men",
            childSubCategory: (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.category) ? router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.category : "",
            isShopifyProduct: false,
            page: page,
            limit: dataLimite
        }));
    };
    var fetchUpdatedProduct = function(product_id, type) {
        var update_product = [];
        if (type === "dislike") {
            var ref, ref1, ref2;
            update_product = productByCategory === null || productByCategory === void 0 ? void 0 : (ref = productByCategory.product) === null || ref === void 0 ? void 0 : (ref1 = ref.getAllProducts) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.map(function(prd) {
                if ((prd === null || prd === void 0 ? void 0 : prd.id) === product_id) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prd), {
                        likes: null
                    });
                } else {
                    return prd;
                }
            });
        } else if (type === "like") {
            var ref3, ref4, ref5;
            update_product = productByCategory === null || productByCategory === void 0 ? void 0 : (ref3 = productByCategory.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.getAllProducts) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.map(function(prd) {
                if ((prd === null || prd === void 0 ? void 0 : prd.id) === product_id) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prd), {
                        likes: {
                            id: 3.3333
                        }
                    });
                } else {
                    return prd;
                }
            });
        }
        dispatch((0,fetchAllStoresSlice/* setStoreProductState */.nT)({
            getAllProducts: {
                data: update_product
            }
        }));
        fetchProduct();
    };
    var Cards = [
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small"
                },
                {
                    img: s2,
                    type: "small"
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s2,
                    type: "small"
                },
                {
                    img: s1,
                    type: "small"
                }, 
            ]
        },
        {
            img: s4,
            type: "large",
            parent_fill: false,
            child: []
        },
        {
            img: s3,
            type: "large",
            parent_fill: false,
            child: []
        },
        {
            img: null,
            type: null,
            parent_fill: true,
            child: [
                {
                    img: s1,
                    type: "small"
                },
                {
                    img: s2,
                    type: "small"
                }, 
            ]
        }, 
    ];
    // const store = data?.getAllProducts?.data
    var PageDataFun = props.PageDataFun, menStyleData = props.menStyleData;
    var menStyleDetailModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageCategoryDetail) === null || ref === void 0 ? void 0 : ref.data;
    });
    var ref8 = (0,react.useState)(false), showbrandProduct = ref8[0], setShowBrandProduct = ref8[1];
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SamplePrevArrow, {})
    };
    var handleBack = function() {
        if (menStyleData.flag) {
            PageDataFun("FindYourStyle");
        } else {
            PageDataFun("WomansCategory");
        }
    };
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "casual-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "casual-banner",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "casual-banner-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return router.back();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icon/leftArrow.svg",
                                    alt: "left-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "casual-heading-alignment",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: menStyleDetailModal === null || menStyleDetailModal === void 0 ? void 0 : (ref = menStyleDetailModal.id) === null || ref === void 0 ? void 0 : ref.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Lorem ipsum dolor sit amet consectetur adipiscing elitr"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "store-page bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "feature-product-align",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "store-page-cover-info",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllProduct/* default */.Z, {
                            products: productByCategory === null || productByCategory === void 0 ? void 0 : (ref1 = productByCategory.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getAllProducts) === null || ref2 === void 0 ? void 0 : ref2.data,
                            storeId: 0,
                            color: "#FFFFFF",
                            isFilterMenu: true,
                            total: productByCategory === null || productByCategory === void 0 ? void 0 : (ref3 = productByCategory.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.getAllProducts) === null || ref4 === void 0 ? void 0 : ref4.total,
                            isCalled: productByCategory === null || productByCategory === void 0 ? void 0 : productByCategory.called,
                            dataLimite: dataLimite,
                            setPage: setPage,
                            APIcall: fetchUpdatedProduct,
                            page: page,
                            topForFilter: 0,
                            setFilterData: setFilterData,
                            filterData: filterData,
                            fetchUpdatedProduct: fetchUpdatedProduct
                        })
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomenPageModal/index.tsx














function WomenPageModal() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var manageApplianceCategoryModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageApplianceCategoryModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    var menStyleDetailModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageCategoryDetail) === null || ref === void 0 ? void 0 : ref.data;
    });
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.category) {
            var ref12;
            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                modal: "womenShopByCategory",
                isOpen: true,
                id: router === null || router === void 0 ? void 0 : (ref12 = router.query) === null || ref12 === void 0 ? void 0 : ref12.category,
                for: "women",
                type: null
            }));
        }
        if ((router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.type) === "trending") {
            var ref13;
            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                modal: "womenNowTrending",
                isOpen: true,
                id: router === null || router === void 0 ? void 0 : (ref13 = router.query) === null || ref13 === void 0 ? void 0 : ref13.type,
                for: "women",
                type: "trending"
            }));
        }
        if ((router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.type) === "style") {
            var ref14;
            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                modal: "womenFindYourStyle",
                isOpen: true,
                id: router === null || router === void 0 ? void 0 : (ref14 = router.query) === null || ref14 === void 0 ? void 0 : ref14.style,
                for: "women",
                type: "style"
            }));
            dispatch((0,manageCategoryDetail/* manageStyleDetail */.S)({
                modal: "",
                isOpen: false,
                id: 0
            }));
        }
        if ((router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.type) === "club") {
            var ref15;
            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                modal: "womenFashionClub",
                isOpen: true,
                id: router === null || router === void 0 ? void 0 : (ref15 = router.query) === null || ref15 === void 0 ? void 0 : ref15.type,
                for: "women",
                type: "club"
            }));
        }
        if ((router === null || router === void 0 ? void 0 : (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.type) === "store") {
            var ref16;
            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                modal: "womenTrendingStore",
                isOpen: true,
                id: router === null || router === void 0 ? void 0 : (ref16 = router.query) === null || ref16 === void 0 ? void 0 : ref16.type,
                for: "women",
                type: "store"
            }));
        }
        if ((router === null || router === void 0 ? void 0 : (ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.type) === "influencers") {
            var ref17;
            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                modal: "womenfashionInfluencers",
                isOpen: true,
                id: router === null || router === void 0 ? void 0 : (ref17 = router.query) === null || ref17 === void 0 ? void 0 : ref17.type,
                for: "women",
                type: "influencers"
            }));
        }
        if (!((router === null || router === void 0 ? void 0 : (ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.type) || (router === null || router === void 0 ? void 0 : (ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.style) || (router === null || router === void 0 ? void 0 : (ref8 = router.query) === null || ref8 === void 0 ? void 0 : ref8.category) || (router === null || router === void 0 ? void 0 : (ref9 = router.query) === null || ref9 === void 0 ? void 0 : ref9.detail))) {
            dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                modal: "",
                isOpen: false,
                id: 0
            }));
            dispatch((0,manageCategoryDetail/* manageStyleDetail */.S)({
                modal: "",
                isOpen: false,
                id: 0
            }));
        } else {}
        if ((router === null || router === void 0 ? void 0 : (ref10 = router.query) === null || ref10 === void 0 ? void 0 : ref10.type) && (router === null || router === void 0 ? void 0 : (ref11 = router.query) === null || ref11 === void 0 ? void 0 : ref11.detail)) {
            var ref18;
            dispatch((0,manageCategoryDetail/* manageStyleDetail */.S)({
                modal: "womenStyleDetails",
                isOpen: true,
                id: router === null || router === void 0 ? void 0 : (ref18 = router.query) === null || ref18 === void 0 ? void 0 : ref18.detail,
                for: "women",
                type: "styleDetail"
            }));
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overlay ".concat((manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : manageApplianceCategoryModal.isOpen) ? "open" : "")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "special-offer-modal ".concat((manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : manageApplianceCategoryModal.isOpen) ? "open" : ""),
                            style: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sidebar-modal-alignment borderRaduisNone",
                                style: {
                                    padding: 0,
                                    borderRadius: 0
                                },
                                children: [
                                    (manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : manageApplianceCategoryModal.modal) === "womenShopByCategory" && /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenCategoryModalMain, {}),
                                    (manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : manageApplianceCategoryModal.modal) === "womenNowTrending" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingProducts, {}),
                                    (manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : manageApplianceCategoryModal.modal) === "womenFindYourStyle" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FindYourStyle, {}),
                                    (manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : manageApplianceCategoryModal.modal) === "womenFashionClub" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FashionGroups, {}),
                                    (manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : manageApplianceCategoryModal.modal) === "womenTrendingStore" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingStore, {}),
                                    (manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : manageApplianceCategoryModal.modal) === "womenfashionInfluencers" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FashionEnthusiasts, {})
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overlay ".concat((menStyleDetailModal === null || menStyleDetailModal === void 0 ? void 0 : menStyleDetailModal.isOpen) ? "open" : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "special-offer-modal ".concat((menStyleDetailModal === null || menStyleDetailModal === void 0 ? void 0 : menStyleDetailModal.isOpen) ? "open" : ""),
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sidebar-modal-alignment borderRaduisNone",
                            style: {
                                padding: 0,
                                borderRadius: 0
                            },
                            children: (menStyleDetailModal === null || menStyleDetailModal === void 0 ? void 0 : menStyleDetailModal.modal) === "womenStyleDetails" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryFindYourStyle, {})
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/fashion/women/index.tsx





var WomenCategory = function() {
    var manageApplianceCategoryModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageApplianceCategoryModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    (0,react.useEffect)(function() {
        if (manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : manageApplianceCategoryModal.isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
    }, [
        manageApplianceCategoryModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WomansCategory, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenPageModal, {})
        ]
    });
};
/* harmony default export */ var women = (WomenCategory);


/***/ }),

/***/ 30806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FindStyleNodatamain":"FindStyleNodata_FindStyleNodatamain__cPcPb","FindStyleNodatabox":"FindStyleNodata_FindStyleNodatabox__W4IK6"};

/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 60430:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(58); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);